export default __webpack_public_path__ + "static/media/logo_login.150e0ac5.svg";